import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  Result,
  ResultListRequest,
  ResultListResponse,
  ResultUpdateRequest,
} from "./types";

export const resultListService = (params: ResultListRequest) =>
  RestAPIClient.call<ResultListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      params,
      requireAuthentication: true,
    },
  });

export const resultDetailService = (id: string) =>
  RestAPIClient.call<Result>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const resultUpdateService = ({
  id,
  ...innerParams
}: ResultUpdateRequest) =>
  RestAPIClient.call<Result>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${id}`,
    data: innerParams,
    config: {
      requireAuthentication: true,
    },
  });
